import React, { useEffect, useRef } from 'react';
import useExternalScript from '@fec/frontend/foundation/hooks/ExternalScript.js';
import {
  handleWidgetLinks,
  shouldHandleWidgetLinks,
} from '@fec/frontend/snowflakes/article/election-widget/election-widget-linkhandler.js';

export const ElectionWidget = ({ teaser }) => {
  const widgetRef = useRef();
  useExternalScript(teaser.url);

  // Make sure the widget gets initialized
  useEffect(() => {
    if (typeof window?.srgElectionWidgetInit === 'function') {
      window.srgElectionWidgetInit();
    }
  }, []);

  useEffect(() => {
    if (shouldHandleWidgetLinks() && widgetRef?.current) {
      widgetRef.current.addEventListener('click', (e) => handleWidgetLinks(e));
    }
    return () =>
      widgetRef?.current?.removeEventListener('click', (e) =>
        handleWidgetLinks(e),
      );
  }, [widgetRef]);

  return (
    <div
      ref={widgetRef}
      className="js-srg-election-widget election-widget"
      data-js-plugin="srg-election-widget"
      data-id={teaser.id}
      data-case-id={teaser.caseId}
      data-env={teaser.env}
      data-flying-focus-info="no"></div>
  );
};
